document.addEventListener('DOMContentLoaded', function () {

  // ---- galeri: küçük resme tıklayınca ana alanda göster ----
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var wrap = thumb.closest('.product-gallery');
      var mediaId = thumb.dataset.mediaId;
      wrap.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      var main = wrap.querySelector('.gallery-main');
      main.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
        var isMatch = slide.dataset.mediaId === mediaId;
        slide.classList.toggle('active', isMatch);
        // videolar görünür olmadığında durdurulsun
        var video = slide.querySelector('video');
        if (!isMatch && video) { video.pause(); }
      });
    });
  });

  // ---- adet seçici ----
  document.querySelectorAll('.qty-selector').forEach(function (sel) {
    var input = sel.querySelector('[data-qty-input]');
    var minus = sel.querySelector('[data-qty-minus]');
    var plus = sel.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });
    if (plus) plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
    });
  });

  // ---- ürün özellikleri / yorumlar sekmeleri ----
  document.querySelectorAll('[data-tab-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = btn.closest('.product-tabs-nav');
      var container = nav.parentElement;
      nav.querySelectorAll('[data-tab-btn]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      container.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
      var target = document.getElementById(btn.dataset.tabTarget);
      if (target) target.classList.add('active');
    });
  });

  // ---- ürün açıklaması: sabit yükseklik / tümünü göster ----
  document.querySelectorAll('[data-desc-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.product-desc-wrap');
      var desc = wrap.querySelector('[data-product-desc]');
      var label = btn.querySelector('[data-desc-toggle-label]');
      var isOpen = desc.classList.toggle('expanded');
      btn.classList.toggle('is-open', isOpen);
      if (label) label.textContent = isOpen ? 'Daha Az Göster' : 'Daha Fazlasını Göster';
    });
  });

  // ---- link kopyala ----
  document.querySelectorAll('[data-copy-link]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.dataset.copyLink;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url);
      }
      var original = btn.innerHTML;
      btn.setAttribute('aria-label', 'Kopyalandı');
      window.setTimeout(function () { btn.setAttribute('aria-label', 'Linki kopyala'); }, 1500);
    });
  });
});
